import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { AddTaskParameters, EditTaskParameters, GetTaskApiModel } from './tasks.models';

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  public dataObj: TasksSharedData = {
    save: {
        Name: "",
        StartDate: new Date(Date.today()),
        DueDate: null,
        AssignToSelf: true,
        Assignees: [],
        Signoff: true,
        GroupID: 0
    },
    editTaskId: 0
};
  constructor(
    private cvApiService?: CVApiService
  ) { 
    this.cvApiService = this.cvApiService ?? CVApiService.getServiceBase();
  }

  public async loadTasksData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
    try {
        let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        let response = await this.cvApiService.get<GetTaskApiModel>(`/api/v2/dashboards/modules/tasksData/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`, renderEndpoint);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    } catch (err) {
        console.error("Failed getting module render endpoint");
        throw err;
    }
};

public async completeTask(taskId: number) {
    try {
        let response = await this.cvApiService.post(`/api/v2/dashboards/modules/completeTask/${taskId}`);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    }
    catch (err) {
        console.error(`Failed marking task ${taskId} as completed.`);
        throw err;
    }
}

public async addTask() {
    try {
        let response = await this.cvApiService.post(`/api/v2/dashboards/modules/task`, this.dataObj.save);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    }
    catch (err) {
        console.error(`Failed adding new task '${this.dataObj.save.Name}'.`);
        throw err;
    }
}

public async editTask() {
    var sendObj: EditTaskParameters = {
        Task_Id: this.dataObj.editTaskId,
        Name: this.dataObj.save.Name,
        StartDate: this.dataObj.save.StartDate,
        DueDate: this.dataObj.save.DueDate
    };

    try {
        let response = await this.cvApiService.put(`/api/v2/dashboards/modules/task`, sendObj);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    }
    catch (err) {
        console.error(`Failed editing task #${this.dataObj.editTaskId}.`);
        throw err;
    }
}

public async deleteTask(taskId: number) {
    try {
        let response = await this.cvApiService.delete(`/api/v2/dashboards/modules/task/${taskId}`);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    }
    catch (err) {
        console.error(`Failed deleting task #${taskId}.`);
        throw err;
    }
}

public async getCreateTaskPermission()
{
    try {
        const url = "/api/v2/dashboards/modules/tasksData/tasksAssignPermission";
        const response = await this.cvApiService.get<boolean>(url);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else throw response;
    } catch (err) {
        console.error("Failed to get create task permission");
        throw err;
    } 
}
}

export interface TasksSharedData {
  save: AddTaskParameters;
  editTaskId: number;
}